import React from "react";
import { useNavigate } from "react-router-dom";
import "./AccessDenied.scss"; 

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="access-denied-container">
      <h1>Access Denied</h1>
      <p>You don’t have permission to access this page.</p>
      <button className="h-btn" onClick={() => navigate("/")}>
        Back to Home
      </button>
    </div>
  );
};

export default AccessDenied;
